import { AccountId, PROGRAM_ACCOUNTS } from 'src/constants/GlobalConstants';
import { IdentityTypes } from 'src/state/slice/models/CaseLifecycleTypes';
import {
  FORESIGHT_ACCOUNT_IDS,
  FORESIGHT_DEFAULT_ROLES_INTERNAL,
} from 'src/self-service/constants/ForesightUMSConstants';

const PSC_DEFAULT_ROLES_EXTERNAL = [
  {
    name: 'Regulator',
  },
];

const DEFAULT_ROLES_INTERNAL_USER = [
  {
    name: 'Program Manager',
  },
];

const GTS_DEFAULT_ROLES_EXTERNAL = [
  {
    name: 'Customs Broker',
  },
];

const TRUSTED_CONSUMER_DEFAULT_ROLES_EXTERNAL = [
  {
    name: 'Trusted Partner',
  },
  {
    name: 'Selling Partner',
  },
  {
    name: 'Influential',
  },
];

const SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS_DEFAULT_ROLES_EXTERNAL = [
  {
    name: 'Auditor',
  },
];

const ARTIFACT_CENTRAL_ROLES_EXTERNAL = [
  {
    name: 'Logistics Provider',
  },
];
const DSA_OOCS_ROLES_EXTERNAL = [
  {
    name: 'Dispute Resolution Provider',
  },
];

const RISC_NA_ROLES_EXTERNAL = [
  {
    name: 'Regulator',
  },
];

export const pscRoleMapping = (): { [key: string]: any } => {
  return AccountId.PRODUCT_SAFETY.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]: PSC_DEFAULT_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const socialResponsibilityAuditRequestRoleMapping = (): {
  [key: string]: any;
} => {
  return AccountId.SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS.reduce(
    (accumulated, accountId) => {
      accumulated[accountId] = {
        roles: {
          [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]:
            SOCIAL_RESPONSIBILITY_AUDIT_REQUESTS_DEFAULT_ROLES_EXTERNAL,
          [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
        },
      };
      return accumulated;
    },
    {},
  );
};

export const gtsRoleMapping = (): { [key: string]: any } => {
  return AccountId.GTS.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]: GTS_DEFAULT_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const artifactCentralRoleMapping = (): { [key: string]: any } => {
  return AccountId.ARTIFACT_CENTRAL.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]:
          ARTIFACT_CENTRAL_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const dsaOocsRoleMapping = (): { [key: string]: any } => {
  return AccountId.DSA_OUT_OF_COURT_SETTLEMENT.reduce(
    (accumulated, accountId) => {
      accumulated[accountId] = {
        roles: {
          [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]: DSA_OOCS_ROLES_EXTERNAL,
          [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
        },
      };
      return accumulated;
    },
    {},
  );
};

export const euDSATrustedFlaggerRoleMapping = (): { [key: string]: any } => {
  return AccountId.EU_DSA_TRUSTED_FLAGGER.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const foodSafetyNARoleMapping = (): { [key: string]: any } => {
  return AccountId.FOOD_SAFETY_NA.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const eprEUInternalRoleMapping = (): { [key: string]: any } => {
  return AccountId.EPR_EU_INTERNAL.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]: PSC_DEFAULT_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const sustainabilityRoleMapping = (): { [key: string]: any } => {
  return AccountId.SUSTAINABILITY.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const csamRoleMapping = (): { [key: string]: any } => {
  return AccountId.CSAM.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const dsaPocRoleMapping = (): { [key: string]: any } => {
  return AccountId.DSA_POC.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const paymentServicesComplaintRoleMapping = (): {
  [key: string]: any;
} => {
  return AccountId.PAYMENTS_SERVICES_COMPLAINT.reduce(
    (accumulated, accountId) => {
      accumulated[accountId] = {
        roles: {
          [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
        },
      };
      return accumulated;
    },
    {},
  );
};

export const trustedConsumerRoleMapping = (): { [key: string]: any } => {
  return AccountId.TRUSTED_CONSUMER.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]:
          TRUSTED_CONSUMER_DEFAULT_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const riscCpscRoleMapping = (): { [key: string]: any } => {
  return AccountId.RISC_CPSC_NA.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.EXTERNAL_CUSTOMER_EMAIL]: RISC_NA_ROLES_EXTERNAL,
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const jpCustomsRoleMapping = (): { [key: string]: any } => {
  return AccountId.JP_CUSTOMS.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const jpmaRoleMapping = (): { [key: string]: any } => {
  return AccountId.JPMA.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: DEFAULT_ROLES_INTERNAL_USER,
      },
    };
    return accumulated;
  }, {});
};

export const foresightRoleMapping = (): { [key: string]: any } => {
  return FORESIGHT_ACCOUNT_IDS.reduce((accumulated, accountId) => {
    accumulated[accountId] = {
      roles: {
        [IdentityTypes.INTERNAL_USER_ALIAS]: FORESIGHT_DEFAULT_ROLES_INTERNAL,
      },
    };
    return accumulated;
  }, {});
};

export interface RoleDefinition {
  name: string;
}

export const ACCOUNT_ROLE_MAPPING: {
  [key: string]: {
    roles: {
      [key: string]: RoleDefinition[];
    };
  };
} = {
  ...trustedConsumerRoleMapping(),
  ...euDSATrustedFlaggerRoleMapping(),
  ...foodSafetyNARoleMapping(),
  ...eprEUInternalRoleMapping(),
  ...sustainabilityRoleMapping(),
  ...csamRoleMapping(),
  ...paymentServicesComplaintRoleMapping(),
  ...pscRoleMapping(),
  ...gtsRoleMapping(),
  ...socialResponsibilityAuditRequestRoleMapping(),
  ...artifactCentralRoleMapping(),
  ...dsaOocsRoleMapping(),
  ...jpCustomsRoleMapping(),
  ...jpmaRoleMapping(),
  ...riscCpscRoleMapping(),
  ...dsaPocRoleMapping(),
  ...foresightRoleMapping(),
};
